/**
 * BLE gateway / report problems make live metrics nonsensical — hide dash status
 * chips and the main right-slot label (stale temp, open/closed, etc.).
 */
export const BLE_DASH_STATUS_INVALIDATING_ERRORS = new Set([
	'bleDisabled',
	'gatewayReportOlderThanDay',
]);

export const hasBleDashStatusInvalidatingNotification = (
	notifications: { [category: string]: { error?: string } | null | undefined } | null | undefined,
): boolean =>
	Object.values(notifications || {}).some(
		(notification) =>
			!!notification?.error && BLE_DASH_STATUS_INVALIDATING_ERRORS.has(notification.error),
	);
